<fn-modal-header class="modal-header">
  <h5 class="modal-title" mat-dialog-title>Info Model</h5>
  <button
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</fn-modal-header>
<mat-dialog-content>
  @if(validObjectHash.length == 0){
  <div class="no_data_display">
    {{ "No Data To Display" }}
  </div>
  } @if(validObjectHash.length != 0){
  <div class="row m-0">
    <div class="col-12">
      <table class="table table-hover table-striped table-bordered">
        <colgroup>
          <col width="30%" />
          <col width="70%" />
        </colgroup>
        <thead>
          <tr>
            <th>Key</th>
            <th class="text-center">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let obj of validObjectHash">
            <td>{{ obj.key }}</td>
            <td>
              <ng-container
                *ngIf="obj.key !== 'Sql Reporting Data'; else sqlRptData"
              >
                <ng-container *ngIf="!obj.isLink; else linkTemplate">
                  <ng-container
                    *ngIf="isObjectOrArray(obj.value); else stringTemplate"
                  >
                    <pre>{{ obj.value | json }}</pre>
                  </ng-container>
                  <ng-template #stringTemplate>{{ obj.value }}</ng-template>
                </ng-container>
                <ng-template #linkTemplate>
                  <a [href]="obj.value" target="_blank">{{ obj.value }}</a>
                </ng-template>
              </ng-container>
              <ng-template #sqlRptData>
                <ng-container *ngIf="obj.value?.length > 3 ; else showJsonData">
                  <div class="text-center">
                    <fn-button
                      [type]="'success'"
                      [btnClass]="'btn-sm btn-round'"
                      [text]="'Download'"
                      (click)="downloadRptData()"
                    ></fn-button>
                  </div>
                </ng-container>
                <ng-template #showJsonData>
                  <pre>{{ obj.value | json }}</pre>
                </ng-template>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  }
</mat-dialog-content>
<mat-dialog-actions> </mat-dialog-actions>
